import React, { Component } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'jquery';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import AccountCircle from '@material-ui/icons/AccountCircle';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MenuIcon from '@material-ui/icons/Menu';

import MissionIcon from 'img/icons8-rocket-white-96.png';

import {
  PrimaryDrawerItems,
  SecondaryDrawerItems,
  TertiaryDrawerItems,
  QuaternaryDrawerItems,
  ClientsDrawerItems,
} from './MenuDrawerItems';
import Help from 'components/admin/Help';
import { showHelp, showMissions } from 'store/actions/help';
import * as routes from '../../constants/routes';
import { auth } from '../../firebase';
import { generateTestData } from 'firebase/database/testData';
import { startAddProject } from 'store/actions/projects';

const drawerWidthOpen = 220;
const drawerWidthClosed = 70;
const drawerWidth = drawerWidthOpen;

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  flex: {
    flex: 1,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'fixed',
    zIndex: theme.zIndex.menu,
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  drawerOverlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
  },
  contentMain: {
    flexGrow: 1,
  },
  contentRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
});
//    backgroundColor: "#F6F6F6",
//TODO: determine best approach for handling binding context. eg.
//via bind or via arrow runction. (handleResize() vs handledDrawerOpen)
class MenuAppDrawer extends Component {
  constructor(props) {
    super(props);
    const open = $(window).width() < 1400 ? false : true;
    const drawerWidth = open ? drawerWidthOpen : drawerWidthClosed;
    this.state = {
      anchorEl: null,
      open: open,
      drawerWidth: drawerWidth
    };
  }

  componentDidMount() {
    const drawerWidth = $('#drawer').width();
    this.setState({drawerWidth: drawerWidth});
  }

  handleDrawerOpen = () => {
    console.log("OPTEN DFDSLFSDFSDFDSF")
    this.setState({ open: true, drawerWidth: drawerWidth });
  };

  handleDrawerClose = () => {
    console.log("CLOSE DFDSLFSDFSDFDSF")
    this.setState({ open: false, drawerWidth: this.props.theme.spacing.unit * 9 });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = (event) => {
    this.setState({ anchorEl: null });
  };

  handleAccount() {
    this.props.history.push(routes.ACCOUNT);
    this.setState({ anchorEl: null });
  }

  handleSignIn() {
    this.props.history.push(routes.SIGN_IN);
  }

  handleSignUp() {
    this.props.history.push(routes.SIGN_UP);
  }

  handleSignOut() {
    auth.doSignOut();
    this.setState({ anchorEl: null });
  }

  render() {
    const {
      admin,
      authUser,
      help,
      classes,
      theme,
      companyName,
      showHelp,
      showMissions,
      startAddProject
    } = this.props;
    const { anchorEl, open } = this.state;
    const accountOpen = Boolean(anchorEl);
    const selectedDrawerItem = admin.selectedDrawerItem
      ? ` - ${admin.selectedDrawerItem}`
      : "";

    return(
      <div className={classes.root}>
        <Help />
        <AppBar
          position="fixed"
          className={classNames(classes.appBar, open && classes.appBarShift)}
        >
          <Toolbar disableGutters={!open}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={this.handleDrawerOpen}
              className={classNames(classes.menuButton, open && classes.hide)}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="title" color="inherit" noWrap className={classes.flex}>
              {`${companyName}${selectedDrawerItem}`}
            </Typography>
            {false &&
              <Button onClick={() => {
                  const params = {
                    includes: []
                  }
                  //hack to get redux thunk actions into the generate function
                  const actions = new Map();
                  actions.set("addProject", startAddProject);
                  // fetch('./reallybigfile.json')
                  //   .then(response => response.json())
                  //   .then(data => data.slice(340048, 340940).reduce((catData, chunk) => catData + chunk.body.slice(5, -2), ""))
                  //   .then(catData => console.log("CAT DATA:", catData))
                  //   .catch(err => console.log("probably out of memory, try rebooting"));

                  //generateTestData(params, actions);
                }}>
                Generate Test Data
              </Button>
            }
            <IconButton
              style={{ marginRight: '15px' }}
              onClick={() => showMissions()}
              color="inherit"
            >
              <img
                style={{ width: '25px' }}
                src={MissionIcon}
                alt="Missions" />
            </IconButton>
            {false &&
              <Button
                onClick={() => showHelp()}
              >Help</Button>
            }

            {!authUser && (
              <div>
                <Button color="inherit" onClick={this.handleSignUp.bind(this)}>SIGNUP</Button>
                <Button color="inherit" onClick={this.handleSignIn.bind(this)}>LOGIN</Button>
              </div>
            )}
            {authUser && (
              <div>
                <IconButton
                  aria-owns={accountOpen ? 'menu-appbar' : null}
                  aria-haspopup="true"
                  onClick={this.handleMenu}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={accountOpen}
                  onClose={this.handleClose}
                >
                  <MenuItem onClick={this.handleSignOut.bind(this)}>Sign Out</MenuItem>
                  <MenuItem onClick={this.handleAccount.bind(this)}>My account</MenuItem>
                </Menu>
              </div>
            )}
          </Toolbar>
        </AppBar>
        <Drawer

          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
          }}
          open={open}
        >
          {(help.showHelp || help.currentMission.inProgress) &&
            <div style={{
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              position: 'absolute',
              zIndex: theme.zIndex.menu
            }}/>
          }
          <div className={classes.toolbar}>
            <IconButton onClick={open ? this.handleDrawerClose : this.handleDrawerOpen}>
              {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
            {false &&
              <IconButton onClick={this.handleDrawerClose}>
                {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
              </IconButton>
            }
          </div>
          <Divider />
          <SecondaryDrawerItems />
          <Divider />
          <QuaternaryDrawerItems />
          <Divider />
          <TertiaryDrawerItems />
        </Drawer>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <div className={classes.contentRow}>
            <div style={{ flexGrow: 0, flexShrink: 0, width: `${this.state.drawerWidth}px` }}>
              test
            </div>
            <div className={classes.contentMain}>
              {this.props.children}
            </div>
          </div>
        </main>
      </div>
    );
  }
}

MenuAppDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const { organizations } = state.accountState;
  const organization = organizations[0] ? organizations[0] : {};
  const { name } = organization.about ? organization.about : {};

  return ({
    authUser: state.sessionState.authUser,
    admin: state.adminState,
    companyName: name,
    help: state.help,
  });
}

const mapDispatchToProps = {
  showMissions,
  showHelp,
  startAddProject
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withStyles(styles, { withTheme: true })
)(MenuAppDrawer);



// WEBPACK FOOTER //
// ./src/components/admin/MenuAppDrawer.jsx